// src/chains/avalanche.js - Avalanche C-Chain configuration with SushiSwap API support
import { createChainConfig } from './chainConfig';

export const avalancheConfig = createChainConfig({
  key: 'avalanche', 
  chainId: 43114,
  name: 'Avalanche C-Chain',
  rpcUrl: 'https://0xrpc.io/avax',
  explorerUrl: 'https://snowtrace.io',

  // Native token information
  nativeTokenSymbol: 'AVAX',
  nativeTokenName: 'Avalanche',
  nativeTokenIcon: 'https://i.imgur.com/u2DxZAY.png',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7', // WAVAX on Avalanche
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=avalanche-2&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'avalanche-2',
  geckoTerminalId: 'avax',
  tokenListUrl: 'https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/avalanche.json',
  
  // Use SushiSwap API instead of KyberSwap API or direct contract calls
  aggregatorAddress: 'SushiSwap', // Special value indicating SushiSwap API usage
  sushiswapConfig: {
    // Base URL of the SushiSwap API
    apiBaseUrl: 'https://api.sushi.com',
    // SushiSwap router address for Avalanche
    routerAddress: '0xAC4c6e212A361c968F1725b4d055b47E63F80b75' 
  },
  
  // Keep the old aggregator address for reference or fallback
  legacyAggregatorAddress: '0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865',
  
  // Transaction support
  supportsEIP1559: true,
  
  // Optional: specifying transaction history API endpoint
  txHistoryApi: 'https://api.routescan.io/v2/network/mainnet/evm/43114/address/{address}/transactions'
});